// tslint:disable:object-literal-sort-keys

export const grey = {
  '50': '#f8f8f8',
  '100': '#e5e5e5',
  '200': '#cacaca',
  '300': '#b0b0b0',
  '400': '#525252',
  '500': '#7b7b7b',
  '600': '#6d6d6d',
  '700': '#525252',
  '800': '#373737',
  '900': '#212121'
};

export const red = {
  '50': '#ff2c2c'
};

export const blue = {
  '50': '#f2f7fa',
  '100': '#cce7f5',
  '200': '#99d0ec',
  '300': '#66b8e2',
  '400': '#33a0d8',
  '500': '#0089ce',
  '600': '#007fbf',
  '700': '#0074af',
  '800': '#005795',
  '900': '#003c74'
};

export const green = {
  '50': '#f5faf7',
  '100': '#d9ede0',
  '200': '#b3dbc1',
  '300': '#8cc9a2',
  '400': '#66b783',
  '500': '#40a564',
  '600': '#2f8a50',
  '700': '#2a814a',
  '800': '#21723f',
  '900': '#1c6537'
};



// WEBPACK FOOTER //
// ./src/config/colors.ts